import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { ExternalAppApi } from '../../../api-client';
import { getApiConfiguration } from '../../../common';

type UseDeleteExternalApp = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>, ErrorResponse, string>, 'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, string>;

export const useDeleteCustomRole: UseDeleteExternalApp = (options) => {
  const externalAppsApi = new ExternalAppApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation((id: string) => externalAppsApi.deleteExternalApp(id, tenantId), options);
};
